module.exports = __webpack_public_path__ + "static/media/REPORT-COUNT-3.dc637328.png";